import React from 'react';
import './terms.css';

function TermsAndConditions() {
  return (
    <div className="terms-container">
      <h1>Terms and Conditions</h1>
      <p>
        Welcome to Eye Care Optical. These Terms and Conditions govern your use of our website and the purchase and sale of products from our platform.
        By accessing and using our website, you agree to comply with these terms. Please read them carefully before proceeding with any transactions.
      </p>

      <h2>Use of the Website</h2>
      <ul>
        <li>You must be at least <strong>14</strong> years old to use our website or make purchases.</li>
        <li>You are responsible for maintaining the confidentiality of your account information, including your username and password.</li>
        <li>You agree to provide accurate and current information during the registration and checkout process.</li>
        <li>You may not use our website for any unlawful or unauthorized purposes.</li>
      </ul>

      <h2>Product Information and Pricing</h2>
      <ul>
        <li>We strive to provide accurate product descriptions, images, and pricing information, but we do not guarantee their accuracy.</li>
        <li>Prices are subject to change without notice. Any promotions or discounts are valid for a limited time.</li>
      </ul>

      <h2>Orders and Payments</h2>
      <ul>
        <li>By placing an order, you are making an offer to purchase the selected products.</li>
        <li>We reserve the right to refuse or cancel any order for reasons such as product availability, pricing errors, or suspected fraud.</li>
        <li>You agree to provide valid and up-to-date payment information.</li>
        <li>Payments are processed securely through trusted third-party payment processors.</li>
      </ul>

      <h2>Shipping and Delivery</h2>
      <p>
        We will make reasonable efforts to ensure timely shipping and delivery of your orders. However, shipping times may vary based on your location and other factors.
      </p>

      <h2>Returns and Refunds</h2>
      <p>
        Please refer to our <a href="/refundpolicy">Returns and Refund Policy</a> for information regarding product returns and refunds.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        All content on this website, including text, images, logos, and graphics, is protected by intellectual property laws and belongs to Eye Care Optical or its licensors.
        Unauthorized use, reproduction, or distribution is prohibited.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        We shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of our website or products.
      </p>

      <h2>Amendments and Termination</h2>
      <p>
        We reserve the right to update or terminate these Terms and Conditions at any time without prior notice. Please review them periodically.
      </p>
    </div>
  );
}

export default TermsAndConditions;

